const PUSH = (state, payload) => {
  const exp = payload.key.split(':')

  state.processes.push({
    key: payload.key,
    table_id: parseInt(exp[exp.findIndex(x => x === 't') + 1]),
    bundle_id: parseInt(exp[exp.findIndex(x => x === 'b') + 1]),
    type: parseInt(payload.state.type),
    done: parseInt(payload.state.done),
    total: parseInt(payload.state.total)
  })
}

const UPDATE = (state, payload) => {
  const idx = state.processes.findIndex(x => x.key === payload.key)

  if (idx !== -1) {
    state.processes[idx].done = parseInt(payload.done)
  }
}

const REMOVE = (state, key) => {
  const idx = state.processes.findIndex(x => x.key === key)

  if (idx !== -1) {
    state.processes.splice(idx, 1)
  }
}

export default {
  PUSH,
  UPDATE,
  REMOVE
}
